<div class="row">
  <div class="col-12 mb-2">
    <div>
      <div class="row mb-2">
        <div class="col-xl-8 col-md-12">
          <div class="d-flex align-items-baseline">
            <label class="form-check-label me-2 required-star" for="">
              {{ title ? title : ("common.addresses" | translate) }}
            </label>
            <div
              *ngIf="isSubmit && (form.controls['addresses'].errors?.['missingAddress'] || form.controls['addresses'].errors?.['required'])"
              class="required"
            >
              {{ "common.address-req" | translate }}
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-12 right-end">
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs ms-2"
            (click)="newHeadItem()"
          >
            <i class="fas fa-add"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 mb-2" *ngIf="newAddressItem">
    <div class="card p-3 mb-2">
      <div class="row mb-2 text-center">
        <div class="col-xl-3">
          <p-dropdown
            [options]="titles"
            placeholder="{{ 'general.title' | translate }}"
            [(ngModel)]="newAddressData.title"
            optionLabel="label"
            appendTo="body"
          >
          </p-dropdown>
        </div>
        <div class="col-xl-5">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              disabled
              [(ngModel)]="newAddressData.formattedAddress"
              readonly
              placeholder="{{ 'shared-components.address' | translate }}"
            />
            <span class="input-group-text" (click)="openAddressModal()" role="button"  tabindex="-1">
              <i class="bi bi-search"></i>
            </span>
          </div>
        </div>
        <div class="col-xl-1">
          <input
            class="form-check-input"
            type="checkbox"
            role="switch"
            [(ngModel)]="newAddressData.isPriority"
            aria-checked="true"
          />
        </div>
        <div class="col-xl-2">
          <button
            class="btn btn-sm btn-primary"
            (click)="addAddress()"
            [disabled]="!newAddressData.city || !newAddressData.title?.value"
          >
            {{ "general.add" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="col-12"
    *ngFor="let item of addressItems; let i = index; trackBy: trackByFn"
  >
    <div
      class="card p-3 border mb-2"
      *ngIf="editingIndex !== i; else editingRow"
    >
      <div class="row mb-2 text-center">
        <div class="col-xl-1">
          <i
            class="fa fa-star"
            [ngStyle]="{ color: item?.isPriority ? 'blue' : 'gray' }"
            style="color: blue"
          ></i>
        </div>
        <div class="col-xl-2 text-truncate">
          <i class="fa fa-email" style="color: blue"></i>
          {{ item?.title?.label || item?.title?.value?.label }}
        </div>

        <div class="col-xl-6 text-truncate">
          {{ item?.formattedAddress }}
        </div>
        <div class="col-xl-3 text-end">
          <button
            type="button"
            class="btn btn-sm btn-warning btn-icon-xxs me-1"
            (click)="edit(item, i)"
          >
            <i class="fas fa-pencil-alt"></i>
          </button>
          <button
            type="button"
            class="btn btn-sm btn-danger btn-icon-xxs"
            (click)="deleteItem(i)"
          >
            <i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </div>
    </div>

    <ng-template class="card p-3" #editingRow>
      <div class="card p-3 mb-2">
        <div class="row align-items-center mb-2">
          <div class="col-xl-3">
            <p-dropdown
              [options]="titles"
              placeholder="{{ 'general.title' | translate }}"
              [(ngModel)]="selectedRow.title"
              optionLabel="label"
              appendTo="body"
            ></p-dropdown>
          </div>

          <div class="col-xl-5">
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                [value]="selectedRow?.formattedAddress"
                disabled
                readonly
                placeholder="'item?.city'"
              />
              <span class="input-group-text" (click)="openAddressModal(item)" role="button"  tabindex="-1">
                <i class="bi bi-search"></i>
                <!-- Bootstrap search icon -->
              </span>
            </div>
          </div>
          <div class="col-xl-1">
            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              [(ngModel)]="selectedRow.isPriority"
              aria-checked="true"
            />
          </div>
          <div class="col-xl-3">
            <div class="float-right">
              <button
                type="button"
                class="btn btn-sm btn-warning btn-icon-xxs me-1"
                (click)="saveItem()"
                [disabled]="!item.city || !item.title"
              >
                <i class="fas fa-save"></i>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-danger btn-icon-xxs"
                (click)="cancel()"
              >
                <i class="fas fa-close"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>

<core-address-autocomplete
  #addressComponent
  (setAddress)="handleSetAddress($event)"
>
</core-address-autocomplete>
